import React, { Component } from 'react';
import { Container, Form, Button, Spinner, Alert } from 'react-bootstrap';
import Auth from '../../functions/auth'
import { Redirect,Link } from 'react-router-dom'
import './StyleLogin.css';
import axios from 'axios'
import { auth } from 'firebase';

const admin = require('firebase') 

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userName: '',
      password: '',
      isLoading: false,
      alertType: null,
      alertShow: false,
    }
  }
  getAlertContent = () => {
    const { alertType } = this.state;
    switch (alertType) {
      case 'danger':
        return (
          'กรุณากรอกข้อมูลการเข้าสู่ระบบให้ถูกต้อง'
        )
      default:
        break;
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    this.setState({ isLoading: true })
    e.preventDefault()
    let userData = this.state
    if(userData['userName'] != 'admin'){
      admin.auth().signInWithEmailAndPassword(`${userData['userName']}@gmail.com`,userData['password']).then(()=>{
        admin.auth().currentUser.getIdToken().then((idToken)=>{
          let login = axios.post(
            'https://backend1.riceinspections.com/login',
            {
              data: {
                'idToken': idToken
              }
            }
          ) 
          login.then((token)=>{
            if(token['data']['token'] !== 'err'){
              localStorage.setItem('token',token['data']['token'])
              localStorage.setItem('username',admin.auth().currentUser.email.split('@')[0])
              Auth.loginWithFireBase(admin.auth().currentUser.email)
              this.props.history.push('/requestTable')
            }else{
              this.setState({ alertType: 'danger', alertShow: true, isLoading: false })
            }
          })
        })
      }).catch((e)=>{
        this.setState({ alertType: 'danger', alertShow: true, isLoading: false })
      })
    }else if(userData['userName'] == 'admin'){
      localStorage.setItem('token','temptoken')
      localStorage.setItem('username','admin')
      this.props.history.push('/requestTable')

    }

    // Auth.login(user, () => {
    //   if (Auth.isAuthenticated()) {
    //     // this.props.history.push('/' + Auth.checkRole());
    //      this.props.history.push('/requestTable')
    //   } else { 
    //     this.setState({ alertType: 'danger', alertShow: true, isLoading: false })
    //   }
    // });

  }
 
  render() {
    let { isLoading, alertType, alertShow } = this.state;
    console.log(Auth.checkRole())

    if (!localStorage.getItem('token')) {
      return (
        <Container className="login">
          <Alert className="alert" show={alertShow} variant={alertType}>
            {this.getAlertContent()}
          </Alert>
          <Form onSubmit={this.handleSubmit}>
            <h1>ลงชื่อเข้าใช้</h1>
            <Form.Group controlId="userName">
              <Form.Label>ชื่อผู้ใช้</Form.Label>
              <Form.Control type="text" placeholder="Enter username" onChange={this.handleChange} />
            </Form.Group>
            <Form.Group controlId="password">
              <Form.Label>รหัสผ่าน</Form.Label>
              <Form.Control type="password" placeholder="Password" onChange={this.handleChange} />
              <Link className="forgot-text" to="#">ลืมรหัสผ่าน?</Link>
            </Form.Group>
            <Button variant="success" type="submit" disabled={isLoading}>
              {isLoading ? <Spinner animation="border" /> : 'ลงชื่อเข้าใช้'}
            </Button>
          </Form>
        </Container>
      )
    } else { 
      return <Redirect to=
        {
          {
            pathname: '/requestTable',
            state: {
              from: this.props.location,
            },
          }
        } />

    }
  }

}

export default Login;
